module.exports = {"231025100":"林口镇","231025101":"古城镇","231025102":"刁翎镇","231025104":"朱家镇","231025105":"柳树镇","231025106":"三道通镇","231025107":"龙爪镇","231025108":"莲花镇","231025110":"青山镇","231025111":"建堂镇","231025112":"奎山镇","231025400":"林口林业局"}


//////////////////
// WEBPACK FOOTER
// ./src/town/231025.json
// module id = 778
// module chunks = 0